import React from "react";

interface Props {
  color?: string;
}

const CaretDoubleUp = ({ color = "#101828" }: Props) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5 12.5L8.5 7.5L13.5 12.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 7.5L8.5 2.5L13.5 7.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CaretDoubleUp;
